export const useEventsStore = defineStore('StoreEvents', {
    getters: {
        getEvents:
            (state) =>
            ({isUpcoming, limitTo}: any) => {
                let events = state.events.filter(
                    (event) => isUpcoming === undefined || !isUpcoming || event.date > new Date(),
                );
                return limitTo ? events.slice(0, limitTo) : events;
            },
    },
    state: () => ({
        events: [
            {date: new Date('2025-01-03T00:00:00Z'), name: 'Workshop Aix-en-Provence', state: 'France', website: null},
            {
                date: new Date('2025-01-09T00:00:00Z'),
                name: 'BudaFest',
                state: 'Hungary',
                website: 'https://wcs-budafest.com/',
            },
            {
                date: new Date('2025-01-23T00:00:00Z'),
                name: 'Swing Resolution',
                state: 'Scotland',
                website: 'https://swingresolution.com/',
            },
            {date: new Date('2025-01-28T00:00:00Z'), name: 'Workshop Weekend', state: 'South Africa', website: null},
            {
                date: new Date('2025-02-06T00:00:00Z'),
                name: 'Trinity Swing',
                state: 'Ireland',
                website: 'https://trinityswing.com/',
            },
            {
                date: new Date('2025-02-14T00:00:00Z'),
                name: 'Valentine Swing',
                state: 'Sweden',
                website: 'https://valentineswing.dance/',
            },
            {
                date: new Date('2025-02-21T00:00:00Z'),
                name: 'Winter Coast Swing',
                state: 'Finland',
                website: 'https://www.wintercoastswing.com/',
            },
            {date: new Date('2025-02-28T00:00:00Z'), name: 'Den Haag Workshop', state: 'Netherlands', website: null},
            {
                date: new Date('2025-03-14T00:00:00Z'),
                name: 'Westie Spring Thing',
                state: 'Hungary',
                website: 'https://westiespringthing.com/',
            },
            {
                date: new Date('2025-03-21T00:00:00Z'),
                name: 'King Swing',
                state: 'Poland',
                website: 'http://sdsfirma.nazwa.pl/kingswing//kingswing//kingswing/index.php?lang=en',
            },
            {
                date: new Date('2025-03-27T00:00:00Z'),
                name: 'UK WCS Championships',
                state: 'England',
                website: 'https://www.ukwcschamps.com/',
            },
            {
                date: new Date('2025-04-18T00:00:00Z'),
                name: 'Asia Open WCS',
                state: 'Singapore',
                website: 'https://www.asiawcsopen.com/',
            },
            {
                date: new Date('2025-04-24T00:00:00Z'),
                name: 'SwingIn',
                state: 'Germany',
                website: 'https://tanzhaus-bonn.de/swingin-festival-en/',
            },
            {
                date: new Date('2025-05-02T00:00:00Z'),
                name: 'Spring Time Swing',
                state: 'Germany',
                website: 'https://springtimeswing.com/',
            },
            {
                date: new Date('2025-06-05T00:00:00Z'),
                name: 'Baltic Swing',
                state: 'Poland',
                website: 'https://www.balticswing.com/',
            },
            {
                date: new Date('2025-06-27T00:00:00Z'),
                name: 'Neverland Swing',
                state: 'Netherlands',
                website: 'https://neverlandswing.com/',
            },
            {
                date: new Date('2025-07-05T00:00:00Z'),
                name: 'Sauna Swing',
                state: 'Finland',
                website: 'https://ekarolas.com/saunaswing/',
            },
            {
                date: new Date('2025-07-18T00:00:00Z'),
                name: 'Rock The Barn',
                state: 'Sweden',
                website: 'https://rockthebarn.se/',
            },
            {date: new Date('2025-08-15T00:00:00Z'), name: 'Summer Summit', state: 'Poland', website: null},
            {
                date: new Date('2025-08-22T00:00:00Z'),
                name: 'SOL Swing',
                state: 'Norway',
                website: 'https://www.argomovement.com/events-2/',
            },
            {date: new Date('2025-08-28T00:00:00Z'), name: 'Swing and Hike', state: 'Switzerland', website: null},
            {
                date: new Date('2025-09-12T00:00:00Z'),
                name: 'Bavarian Open',
                state: 'Germany',
                website: 'https://bavarianopen.com/',
            },
            {
                date: new Date('2025-09-19T00:00:00Z'),
                name: 'Finnfest',
                state: 'Finland',
                website: 'https://finnfest.fi/',
            },
            {
                date: new Date('2025-09-26T00:00:00Z'),
                name: 'Mooseland Swing',
                state: 'Sweden',
                website: 'https://mooselandswing.com/',
            },
            {date: new Date('2025-10-03T00:00:00Z'), name: 'Workshop Weekend', state: 'Japan', website: null},
            {
                date: new Date('2025-10-10T00:00:00Z'),
                name: 'Go West',
                state: 'Australia',
                website: 'https://www.gowestswingfest.au/',
            },
            {
                date: new Date('2025-10-16T00:00:00Z'),
                name: 'New Zealand Open',
                state: 'New Zealand',
                website: 'https://www.streetswing.co.nz/the-new-zealand-open',
            },
            {date: new Date('2025-10-31T00:00:00Z'), name: 'Spooky Halloween', state: 'Singapore', website: null},
            {
                date: new Date('2025-11-21T00:00:00Z'),
                name: 'Iruna Westieval',
                state: 'Spain',
                website: 'https://www.irunawestieval.bailamosryr.com/',
            },
            {
                date: new Date('2025-11-26T00:00:00Z'),
                name: 'The Open',
                state: 'California',
                website: 'https://theopenswing.com/',
            },
            {
                date: new Date('2025-12-04T00:00:00Z'),
                name: 'The After Party (TAP)',
                state: 'California',
                website: 'https://tapwcs.com/',
            },
            {
                date: new Date('2025-12-28T00:00:00Z'),
                name: 'Westie Gala',
                state: 'Sweden',
                website: 'https://www.westiegala.com/',
            },
            {
                date: new Date('2026-01-01T00:00:00Z'),
                name: "New Year's Swing Fling",
                state: 'UK',
                website: 'https://www.nysf.uk/',
            },
            {
                date: new Date('2026-03-13T00:00:00Z'),
                name: 'Westie Spring Thing',
                state: 'Hungary',
                website: 'https://westiespringthing.com/',
            },
            {
                date: new Date('2026-03-20T00:00:00Z'),
                name: 'King Swing',
                state: 'Poland',
                website: 'http://sdsfirma.nazwa.pl/kingswing//kingswing//kingswing/index.php?lang=en',
            },
            {
                date: new Date('2026-03-26T00:00:00Z'),
                name: 'UK WCS Championships',
                state: 'England',
                website: 'https://www.ukwcschamps.com/',
            },
            {
                date: new Date('2026-04-10T00:00:00Z'),
                name: 'SwingIn Capital',
                state: 'Italy',
                website: 'https://www.westcoastswingroma.it/swing-in-capital/',
            },
            {
                date: new Date('2026-04-17T00:00:00Z'),
                name: 'Asia Open WCS',
                state: 'Singapore',
                website: 'https://www.asiawcsopen.com/',
            },
            {
                date: new Date('2026-05-01T00:00:00Z'),
                name: 'Spring Time Swing',
                state: 'Germany',
                website: 'https://springtimeswing.com/',
            },
            {
                date: new Date('2026-05-22T00:00:00Z'),
                name: 'Hungarian Open',
                state: 'Hungary',
                website: 'https://wcs-ho.com/',
            },
            {
                date: new Date('2026-06-11T00:00:00Z'),
                name: 'Baltic Swing',
                state: 'Poland',
                website: 'https://www.balticswing.com/',
            },
            {
                date: new Date('2026-07-02T00:00:00Z'),
                name: 'Sauna Swing',
                state: 'Finland',
                website: 'https://ekarolas.com/saunaswing/',
            },
            {
                date: new Date('2026-07-08T00:00:00Z'),
                name: 'MY Swing',
                state: 'Malaysia',
                website: 'https://www.myswingopen.com/',
            },
            {
                date: new Date('2026-07-16T00:00:00Z'),
                name: 'Rock The Barn',
                state: 'Sweden',
                website: 'https://rockthebarn.se/',
            },
            {
                date: new Date('2026-08-31T00:00:00Z'),
                name: 'Lisbon Westie Fest',
                state: 'Portugal',
                website: 'https://lisbonwestiefest.com/',
            },
            {
                date: new Date('2026-08-14T00:00:00Z'),
                name: 'Hike & Dance',
                state: 'Switzerland',
                website: 'https://hikeanddance.ch/',
            },
            {
                date: new Date('2026-08-21T00:00:00Z'),
                name: 'Mannequin Swing',
                state: 'Belgium',
                website: 'https://www.mannekenswing.com/',
            },
            {
                date: new Date('2026-08-28T00:00:00Z'),
                name: 'Rolling Swing',
                state: 'France',
                website: 'https://www.frenchywesty.com/rollingswing',
            },
            {
                date: new Date('2026-09-04T00:00:00Z'),
                name: 'Bretzel Swing',
                state: 'France',
                website: 'https://swingtogether.fr/en/bretzel-swing/',
            },
            {
                date: new Date('2026-10-02T00:00:00Z'),
                name: 'Madrid Westie Fest',
                state: 'Spain',
                website: 'https://wcswingmadrid.com/en/',
            },
            {
                date: new Date('2026-10-23T00:00:00Z'),
                name: 'Augsburg Westie Station',
                state: 'Germany',
                website: 'https://www.augsburgwestiestation.com/',
            },
        ],
    }),
});
